import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import 'leaflet/dist/leaflet.css'; // Importa i fogli di stile di Leaflet
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Crea l'app Vue.js
const app = createApp(App);
const pinia = createPinia();

// Usa il router
app.use(router);
app.use(pinia);

// Monta l'app
app.mount('#app');